import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { toast } from 'sonner';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const deleteAnnouncementAPI = async (id: string) => {
  const response = await baseAPI.delete<{ success: true }>(
    `/announcements/${id}`,
  );
  return response.data;
};

export const useDeleteAnnouncementMutation = () => {
  return useMutation({
    mutationFn: deleteAnnouncementAPI,
    onSuccess: (_data, id) => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ANNOUNCEMENTS],
      });
      queryClient.removeQueries({
        queryKey: [KEYS.ANNOUNCEMENTS, id],
      });
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        error.response?.data?.message ?? 'Failed to delete announcement',
      );
    },
  });
};
